import React, { useState } from 'react';
import clsx from 'clsx';

const WhiteLabel = () => {

    return (
        <section className="home">

            <div className="container" style={{ position: 'relative' }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '50vh',
                    backgroundColor: 'rgba(55, 55, 55, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '1.5em',
                    fontWeight: 'bold',
                    borderRadius: '15px',
                    borderWidth: 4,
                    borderStyle: 'ridge',
                    zIndex: 1,
                }}>
                    <span style={{ fontSize: 22, color: '#919191' }}>Cette fonctionnalité arrive bientôt !</span>
                </div>
            </div>

            <hr className="is-invisible" />

        </section>
    );
};

export default WhiteLabel;